"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET = exports.SAGA = void 0;
var SAGA = 'locale/SAGA';
exports.SAGA = SAGA;
var SET = 'locale/SET';
exports.SET = SET;